import {
  PlannedQtyDeviation,
  PlannedQtyDeviationCreateRequest,
  PlannedQtyDeviationFilterInputs,
  PlannedQtyDeviationUpdateRequest,
} from '../../types/app/plannedQtyDeviation.types';
import { api } from '../core/api';

export const getPlannedQtyDeviationList = (id?: number) =>
  api
    .get<PlannedQtyDeviation[]>(`PlannedQtyDeviation/GetList?parentId=${id}`)
    .then((res) => res.data);

export const getPlannedQtyDeviationListFiltered = (data: PlannedQtyDeviationFilterInputs) =>
  api
    .get<PlannedQtyDeviation[]>(
      `PlannedQtyDeviation/GetListFiltered?parentId=${data.parentId}&from=${data.from}&to=${data.to}`,
    )
    .then((res) => res.data);

export const getPlannedQtyDeviation = (id: number) =>
  api.get<PlannedQtyDeviation>(`PlannedQtyDeviation/GetItem/?id=${id}`).then((res) => res.data);

export const updatePlannedQtyDeviation = (data: PlannedQtyDeviationUpdateRequest) =>
  api.put(`PlannedQtyDeviation/UpdateItem`, data).then((res) => res.data);

export const createPlannedQtyDeviation = (data: PlannedQtyDeviationCreateRequest) =>
  api.post(`PlannedQtyDeviation/CreateItem`, data).then((res) => res.data);

export const deletePlannedQtyDeviation = (id: number) =>
  api.delete<PlannedQtyDeviation>(`PlannedQtyDeviation/DeleteItem/?id=${id}`).then();
